import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import PrivateLayout from "../../components/layouts/PrivateLayout";
import { fetchUserProfile } from "../../store/redux_auth/authSlice";
import LoadingPlaceholder from "../../components/ui/loading/LoadingPlaceholder";

const PrivateRouteV2 = ({
  children,
  showRightSidebar = true,
  showLeftSidebar = true,
  rightSidebarComponent = null,
}) => {
  const [isMounting, setIsMounting] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    isAuthenticated,
    isLoading: isLoadingRedux,
    user,
  } = useSelector((state) => state.auth);
  const url = `/sign-in?path=${encodeURIComponent(
    location.pathname + location.search,
  )}`;

  // Always fetch user profile on mount to verify Knox cookie
  // Knox HTTP-only cookie is the source of truth, not localStorage
  useEffect(() => {
    if (!user && !isLoadingRedux) {
      dispatch(fetchUserProfile());
    }
    if (!isLoadingRedux) {
      setIsMounting(false);
    }
  }, [dispatch, user, isLoadingRedux]);

  // Not authenticated after loading - redirect to sign in
  if (!isAuthenticated || !user) {
    return <Navigate to={url} replace />;
  }

  const showLoading = isMounting || isLoadingRedux;

  return (
    <PrivateLayout
      showLeftSidebar={showLeftSidebar}
      showRightSidebar={showRightSidebar}
      rightSidebarComponent={rightSidebarComponent}
      loading={showLoading}
    >
      {children}
    </PrivateLayout>
  );
};

export default PrivateRouteV2;
